import { uid } from "./core";

interface ICssList {
	[key: string]: string;
}

interface ICssManager {
	update(): void;
	remove(className: string): void;
	add(cssList: ICssList, customId?: string, silent?: boolean): string;
	get(className: string): ICssList;
	destructor(): void;
}

export class CssManager implements ICssManager {
	private _classes: ICssList;
	private _styleCont: HTMLStyleElement;
	constructor() {
		this._classes = {};
		const styles = document.createElement("style");
		styles.id = "dhx_generated_styles";
		this._styleCont = document.head.appendChild(styles);
	}
	update() {
		if (this._styleCont.innerHTML !== this._generateCss()) {
			document.head.appendChild(this._styleCont);
			this._styleCont.innerHTML = this._generateCss();
		}
	}
	remove(className: string) {
		delete this._classes[className];
		this.update();
	}
	add(cssList: ICssList, customId?: string, silent = false): string {
		const cssString = this._toCssString(cssList);

		const id = this._findSameClassId(cssString);

		if (id && customId && customId !== id) {
			this._classes[customId] = this._classes[id];
			return customId;
		}
		if (id) {
			return id;
		}
		return this._addNewClass(cssString, customId, silent);
	}
	get(className: string): ICssList {
		if (this._classes[className]) {
			const props = {};
			const css = this._classes[className].split(";");
			for (const item of css) {
				if (item) {
					const prop = item.split(":");
					props[prop[0]] = prop[1];
				}
			}
			return props;
		}
		return null;
	}
	destructor() {
		this._classes = this._styleCont = null;
	}
	private _findSameClassId(cssString: string): string {
		for (const key in this._classes) {
			if (cssString === this._classes[key]) {
				return key;
			}
		}
		return null;
	}
	private _addNewClass(cssString: string, customId?: string, silent?: boolean): string {
		const id = customId || `dhx_generated_class_${uid()}`;
		this._classes[id] = cssString;
		if (!silent) {
			this.update();
		}
		return id;
	}
	private _toCssString(cssList: ICssList): string {
		let cssString = "";
		for (const key in cssList) {
			const prop = cssList[key];
			const name = key.replace(/[A-Z]{1}/g, letter => `-${letter.toLowerCase()}`);
			cssString += `${name}:${prop};`;
		}
		return cssString;
	}
	private _generateCss(): string {
		let result = "";
		for (const key in this._classes) {
			const cssProps = this._classes[key];
			result += `.${key}{${cssProps}}\n`;
		}
		return result;
	}
}

export const cssManager = new CssManager();
